export default "<p><b>Mail App:</b> - Coming soon in the following update.</p>\n";